import styled from 'styled-components'
import FontAwesome from 'react-fontawesome'
import { sizes } from './style-utils'

export const SelectionNavigator = styled.div`
    width: 100%;
    // max-width: ${sizes.tablet}px;
    height: 44px;
    position: relative;
    border-bottom: 1px solid #ccc;
`

export const SelectionNavigatorTitle = styled.h2`
    width: 100%;
    height: 44px;
    text-align: center;
    font-size: 20px;
    line-height: 44px;
`

export const SelectionNavigatorBackLink = styled.div`
    width: 44px;
    height: 44px;
    text-align: center;
    position: absolute;
    left: 0;
    top: 0;
`

export const SelectionBackImage = styled(FontAwesome)`
    line-height: 44px;
`

export const SelectionNavigatorRightButton = styled.div`
    position: absolute;
    top: 0;
    right: 10px;
    line-height: 44px;
    font-size: 0.9rem;
    color: ${props => (props.isActive ? 'var(--fai-text-color)' : 'var(--fai-disabled-text-color)')};
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Selection.js